<div class="question-view__heatmap-header">
  <span class="question-view__heatmap-header-title fs__sm">
    @if (question.minLength > 0 && question.maxLength > 0) {
      Select at least {{ question.minLength }} and at most {{ question.maxLength }} areas
    } @else if (question.minLength > 0) {
      Select at least {{ question.minLength }} areas
    } @else if (question.maxLength > 0) {
      Select at most {{ question.maxLength }} areas
    }
  </span>
  <button mat-stroked-button (click)="onClear()">
    <fa-icon [icon]="faArrowsRotate"></fa-icon>
    Clear
  </button>
</div>

<div id="heatmapContainer" [style.height]="question.imageHeight + 'px'" [style.width]="question.imageWidth + 'px'">
  <div class="overlay" [style.background-image]="mediaUrl$ | async" [style.background-size]="question.imageFit"></div>
</div>
